import {
  queryPlayForm,
  queryGameList,
  loginGame,
  transform,
  queryGameBettingList,
  queryTransformList,
  regressionAccount,
  queryLotUserAccount,
  queryGameTypes,
  queryTypePlatforms,
  queryPlatformGames,
  queryPlayIndex,
  queryGameListTypes,
  queryGameSearch
} from "@/api/game";
const lottery = {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryGameSearch({ commit }, playload) {
      const { data, config } = playload;
      const blRes = await queryGameSearch(data, config);
      return blRes;
    },
    async queryGameListTypes({ commit }, playload) {
      const { data, config } = playload;
      const blRes = await queryGameListTypes(data, config);
      return blRes;
    },
    async queryGamePlayIndex({ commit }, playload) {
      const blRes = await queryPlayIndex(playload);
      return blRes;
    },
    async queryGamePlayForm({ commit }, playload) {
      const { data, config } = playload;
      const blRes = await queryPlayForm(data, config);
      return blRes;
    },
    async queryGameList({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryGameList(data, config);
      const ret = res.data.data;
      return res;
    },
    async loginGame({ commit }, playload) {
      const { data, config } = playload;
      const res = await loginGame(data, config);
      const ret = res.data.data;
      return res;
    },
    async gameTransform({ commit }, playload) {
      const { data, config } = playload;
      const res = await transform(data, config);
      const ret = res.data.data;
      return res;
    },
    async queryGameBettingList({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryGameBettingList(data, config);
      const ret = res.data.data;
      return res;
    },
    async queryTransformList({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryTransformList(data, config);
      const ret = res.data.data;
      return res;
    },
    async regressionAccount({ commit }, playload) {
      const { data, config } = playload;
      const res = await regressionAccount(data, config);
      const ret = res.data.data;
      return res;
    },
    async queryLotUserAccount({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryLotUserAccount(data, config);
      return res;
    },

    async queryGameTypes({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryGameTypes(data, config);
      return res;
    },
    async queryTypePlatforms({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryTypePlatforms(data, config);
      return res;
    },
    async queryPlatformGames({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryPlatformGames(data, config);
      return res;
    }
  }
};

export default lottery;
